// Agent entity query keys (per §11.4 entity-agent-queries sub-task 1).
//
// All agent queries hang off `queryRoots.agents`. Callers should use
// these helpers instead of writing array literals so cache invalidation
// (e.g. `queryClient.invalidateQueries({ queryKey: agentKeys.catalog() })`)
// is consistent.

import { queryRoots, type QueryKey } from '@/shared/query';

export const agentKeys = {
  all: (): QueryKey => [queryRoots.agents],
  catalog: (): QueryKey => [queryRoots.agents, 'catalog'],
  detail: (agentId: string): QueryKey => [queryRoots.agents, 'detail', agentId],
} as const;
